mtl.alloy.factory['read-more'] = (function($, app, util) {
    'use strict';

    return function(element, options) {

        var $element = $(element);
        var $sibling = $element.siblings().eq(0);

        if($element.height() > $sibling.height())
        {
            var $height = ($element.height() - $sibling.height()) + 100;

            $element.data('original-height', $element.height());

            var $readMore = $('<div class="read-more-container"></div>');
            $readMore.height($height+'px');
            $readMore.css('overflow', 'hidden');
            $element.wrapInner($readMore);

            $('<div class="shade"></div>').appendTo($element);
            $('<a href="#" class="button">Read more</a>').appendTo($element).on('click', function(e){
                e.preventDefault();
                $('.shade', $element).remove();
                $(this).remove();
                $('.read-more-container', $element).animate({
                    'height': $element.data('original-height')+'px'
                });
            });
        }

        $element.addClass('shrunk');
    };

}(jQuery, app, util));
